import React from 'react';

// components and helpers
import ComponentWrapper from '../containers/ComponentWrapper';
import Workspace from '../components/Workspace/Workspace';

// mui
import Grid from '@mui/material/Grid';

const WorkspaceView: React.FC = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Workspace />
            </Grid>
        </Grid>
    );
};

export default ComponentWrapper(WorkspaceView);
